module.exports = __webpack_public_path__ + "static/media/playlist_reorder.4d8c371a.svg";